(function () {
  "use strict";

  const form = document.getElementById('form');
  const result = document.getElementById("result");
  const submitBtn = document.getElementById('submit-btn');
  
  // Reset form on page load
  window.addEventListener('load', function() {
    if (form) {
      form.reset();
    }
    // Initial validation check
    validateForm();
  });

  // Function to validate required fields (without hCaptcha)
  function validateForm() {
    const nameInput = document.querySelector('input[name="Name"]');
    const phoneInput = document.querySelector('input[name="Telephone"]');
    const messageInput = document.querySelector('textarea[name="message"]');
    
    if (!nameInput || !phoneInput || !messageInput || !submitBtn) {
      return;
    }
    
    const nameValue = nameInput.value.trim();
    const phoneValue = phoneInput.value.trim();
    const messageValue = messageInput.value.trim();
    
    // Enable button only if all required fields are filled
    const fieldsValid = nameValue.length > 0 && phoneValue.length > 0 && messageValue.length > 0;
    
    submitBtn.disabled = !fieldsValid;
    submitBtn.style.opacity = fieldsValid ? '1' : '0.6';
    submitBtn.style.cursor = fieldsValid ? 'pointer' : 'not-allowed';
  }

  // Add event listeners to form fields for real-time validation
  document.addEventListener('input', validateForm);
  document.addEventListener('change', validateForm);

  // Form submission with hCaptcha validation
  if (form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      
      // Check required fields first
      const nameInput = document.querySelector('input[name="Name"]');
      const phoneInput = document.querySelector('input[name="Telephone"]');
      const messageInput = document.querySelector('textarea[name="message"]');
      
      const nameValue = nameInput ? nameInput.value.trim() : '';
      const phoneValue = phoneInput ? phoneInput.value.trim() : '';
      const messageValue = messageInput ? messageInput.value.trim() : '';
      
      const fieldsValid = nameValue.length > 0 && phoneValue.length > 0 && messageValue.length > 0;
      
      if (!fieldsValid) {
        if (result) {
          result.innerHTML = "Wypełnij wszystkie wymagane pola.";
          result.className = "text-center text-danger";
          result.style.display = "block";
        }
        return;
      }
      
      // Validate hCaptcha according to documentation
      const hCaptcha = form.querySelector('textarea[name=h-captcha-response]');
      
      if (!hCaptcha || !hCaptcha.value) {
        if (result) {
          result.innerHTML = "Proszę wypełnić pole captcha.";
          result.className = "text-center text-danger";
          result.style.display = "block";
        }
        return;
      }
      
      // All validation passed - submit form
      const formData = new FormData(form);
      const object = Object.fromEntries(formData);
      const json = JSON.stringify(object);
      
      if (result) {
        result.innerHTML = "Wysyłanie...";
        result.style.display = "block";
        result.className = "text-center";
      }

      fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: json,
      })
      .then(async (response) => {
        let json = await response.json();
        
        if (response.status == 200) {
          if (result) {
            result.innerHTML = "Wiadomość została wysłana pomyślnie!";
            result.className = "text-center text-success";
          }
          // Successful submission - redirect after short delay
          setTimeout(() => {
            window.location.href = 'https://autoszyby.swiebodzin.pl/email-success.html';
          }, 1000);
        } else {
          if (result) {
            result.innerHTML = json.message || "Wystąpił błąd podczas wysyłania.";
            result.className = "text-center text-danger";
          }
        }
      })
      .catch((error) => {
        if (result) {
          result.innerHTML = "Wystąpił błąd podczas wysyłania!";
          result.className = "text-center text-danger";
        }
      })
      .then(function () {
        // Reset form after submission
        form.reset();
        
        // Reset button state
        validateForm();
        
        // Hide result message after 5 seconds
        setTimeout(() => {
          if (result) {
            result.style.display = "none";
          }
        }, 5000);
      });
    });
  }

  // Initial validation on page load
  document.addEventListener('DOMContentLoaded', validateForm);
})();